import { CalendarEventResourceModel } from "./CalendarEventResource.model";

export class CalendarEventResource extends CalendarEventResourceModel {
    // Add custom methods here
}
